export default __webpack_public_path__ + "static/media/news1.94dc19e1.png";